/* Fills the brand tile it sits in, whatever that tile's size and radius are —
   the two rails style the tile, this only fills it. */
.icon {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
